import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './styles/global.css'
import { installTheme } from './composables/useTheme'
import { locale } from './i18n'
import { installTestHooks } from './app/testHooks'
import { installCommands } from './commands/all'
import { installActionRecorder } from './automation/actions'

installTheme()
document.documentElement.lang = locale.value

const app = createApp(App)
app.use(createPinia())
app.mount('#app')
installCommands()
installActionRecorder()
installTestHooks()
